import gql from 'graphql-tag';

const identityDetails = gql`
  fragment identityDetails on Identity {
    id
    name
    last_name
    has_outdated_selfie
    relationship
    current_photo {
      id
      thumbnail_urls {
        url
        width
        height
        size_code
      }
    }
    current_matching_photo {
      id
      thumbnail_urls {
        url
        width
        height
        size_code
      }
    }
  }
`;

export default identityDetails;
